<template>
  <l-form class="flex-1 flex" @submit="submit">
    <div
      :class="[
        'flex-1 max-w-4xl flex flex-col gap-5 px-5 lg:px-12 pb-5 lg:justify-center',
        { 'justify-center': center }
      ]"
    >
      <div v-if="$slots.heading" class="text-2xl sm:text-3xl font-serif font-medium text-blue dark:text-white">
        <slot name="heading"/>
      </div>
      <div v-if="$slots.subheading" class="text-gray-600 lg:text-lg">
        <slot name="subheading"/>
      </div>
      <div class="space-y-5 lg:space-y-10">
        <div class="space-y-3">
          <slot name="content"/>

          <div v-if="error" class="text-red font-medium mt-5">
            {{ error }}
          </div>

          <div v-if="$slots.help" class="text-gray-500">
            <slot name="help"/>
          </div>
        </div>

        <div v-if="$slots.cta">
          <slot name="cta"/>
        </div>

        <l-button
          v-else
          type="submit"
          variant="primary"
          size="lg"
          class="px-8"
          :loading="loading"
        >
          <template v-if="loading">
            {{ loadingText }}
          </template>
          <template v-else>
            Next
          </template>
        </l-button>

        <slot name="footer"/>
      </div>
    </div>

    <div v-if="$slots.subcontent" class="hidden flex-1 max-w-5xl size-full bg-blue-100 p-12 lg:flex flex-col items-center justify-center">
      <slot name="subcontent"/>
    </div>
  </l-form>
</template>

<script setup>
import LButton from "@/components/buttons/LButton.vue"
import LForm from "@/components/forms/LForm.vue"
import { ref } from "vue"

const props = defineProps({
  center: { type: Boolean },
  loading: { type: Boolean },
  validate: { type: Function },
  loadingText: { type: String, default: "Loading" },
})

const emit = defineEmits(["next", "validate"])
const error = ref()

const submit = () => {
  if (props.validate) {
    const e = props.validate()

    if (e) {
      error.value = e

      return
    }
  }

  emit("next")
}
</script>
